var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85 640L85 668",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.5,
    cy: 635.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9875 635.19C80.9875 631.283 84.2875 628.117 88.3583 628.117C88.943 628.117 89.511 628.184 90.0563 628.308C88.7423 627.48 87.1872 627 85.5187 627C80.814 627 77 630.806 77 635.5C77 640.194 80.814 644 85.5187 644C87.8136 644 89.8949 643.093 91.4267 641.62C90.4922 642.032 89.4536 642.263 88.3583 642.263C84.2875 642.263 80.9875 639.096 80.9875 635.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4023 634.6L94.3703 632.146L92.5355 633.719L90.3038 633.056L91.1125 635.337L89.7653 637.381L92.0998 637.218L93.4989 639.144L94.133 636.763L96.3449 635.909L94.4023 634.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch8);
export default __webpack_public_path__ + "static/media/church_8.5d0ce4b86e8067816b7b4fd64d55a614.svg";
export { ForwardRef as ReactComponent };